export function isVanClass(className?: string, vehicleName?: string): boolean {
  return /\b(van|minibus|sprinter|vito|mpv)\b/i.test(
    `${className ?? ""} ${vehicleName ?? ""}`
  );
}
